"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsibleCardContent = exports.CollapsibleCardAction = exports.CollapsibleCard = exports.COLLAPSIBLE_CARD_SEMANTIC = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Button = require("../Button");
var _Icon = require("../Icon");
var _Truncate = require("../Truncate");
var _CollapsibleCardModule = _interopRequireDefault(require("./CollapsibleCard.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const COLLAPSIBLE_CARD_SEMANTIC = Object.freeze({
  neutral: 'neutral',
  success: 'success',
  information: 'information',
  warning: 'warning',
  danger: 'danger'
});
exports.COLLAPSIBLE_CARD_SEMANTIC = COLLAPSIBLE_CARD_SEMANTIC;
const CollapsibleCardAction = _ref => {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_CollapsibleCardModule.default.actionContainer, className)
  }, children);
};
exports.CollapsibleCardAction = CollapsibleCardAction;
const CollapsibleCardContent = _ref2 => {
  let {
    children,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_CollapsibleCardModule.default.contentContainer, className)
  }, children);
};
exports.CollapsibleCardContent = CollapsibleCardContent;
const CollapsibleCard = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    id,
    isOpen,
    onChange,
    classNames,
    title,
    children,
    semantic = 'neutral',
    headerIconName,
    headerIconType = 'solid'
  } = _ref3;
  const [collapsibleCardIsOpen, setCollapsibleCardIsOpen] = React.useState(Boolean(isOpen));
  React.useEffect(() => {
    setCollapsibleCardIsOpen(Boolean(isOpen));
  }, [isOpen]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "CollapsibleCard",
    className: (0, _classify.default)(_CollapsibleCardModule.default.wrapper, classNames?.wrapper),
    ref: ref
  }, /*#__PURE__*/React.createElement(_Button.UnstyledButton, {
    className: (0, _classify.default)(_CollapsibleCardModule.default.header, {
      [_CollapsibleCardModule.default.isOpen]: collapsibleCardIsOpen
    }, classNames?.title),
    onClick: e => {
      onChange?.(e, !collapsibleCardIsOpen, id);
      setCollapsibleCardIsOpen(!collapsibleCardIsOpen);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: _CollapsibleCardModule.default.headerContent
  }, !!headerIconName && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_CollapsibleCardModule.default.iconContainer, _CollapsibleCardModule.default[semantic])
  }, /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: headerIconName,
    type: headerIconType,
    size: "small",
    className: _CollapsibleCardModule.default[semantic]
  })), /*#__PURE__*/React.createElement(_Truncate.Truncate, null, title)), collapsibleCardIsOpen ? /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: "chevron-up",
    color: "secondary",
    size: "small"
  }) : /*#__PURE__*/React.createElement(_Icon.Icon, {
    name: "chevron-down",
    color: "secondary",
    size: "small"
  })), collapsibleCardIsOpen && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_CollapsibleCardModule.default.content, classNames?.content)
  }, children));
});
exports.CollapsibleCard = CollapsibleCard;